module.exports = __webpack_public_path__ + "static/media/asterisk.b05f54b9.svg";